import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/home",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/test",
    component: () => import("@/views/test.vue"),
  },
  {
    path: "/scroll",
    component: () => import("@/views/scroll.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
